export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '什么是第一版主？与普通版主有什么区别？',
    answer: '第一版主是论坛社区中拥有最高版块管理权限的核心角色，通常是某个版块的管理团队负责人。与普通版主相比，第一版主不仅负责日常内容管理，还承担团队管理、规则制定和战略规划等更高层级的职责。第一版主拥有更全面的管理权限，同时也需要为版块的整体运营效果负责。',
  },
  {
    question: '成为第一版主需要满足哪些条件？',
    answer: '成为第一版主通常需要满足以下条件：在论坛注册时间超过一年、担任版主或副版主不少于六个月、在目标版块有持续的活跃贡献、无重大违规记录。此外，还需要展示出优秀的内容判断力、团队管理能力、沟通协调能力和战略思维。具体要求可能因论坛规模和类型而有所不同。',
  },
  {
    question: '第一版主的任命流程是怎样的？',
    answer: '第一版主的任命通常经历以下流程：内部推荐或自荐 → 资格审查（审核资历和过往记录）→ 综合评估（面试、案例分析等）→ 公示（接受社区反馈，通常7-14天）→ 正式任命。部分论坛还会设置3个月的试用期，试用期满后进行转正评估。',
  },
  {
    question: '第一版主有哪些核心权限？',
    answer: '第一版主的核心权限包括：帖子管理权限（置顶、精华、删除、移动等）、用户管理权限（禁言、封禁、用户组调整等）、版块设置权限（规则修改、分类调整、积分策略等）、团队管理权限（版主任免、权限分配等）以及数据查看权限（版块数据统计、操作日志等）。',
  },
  {
    question: '如何从普通版主晋升为第一版主？',
    answer: '从普通版主晋升为第一版主需要一个循序渐进的成长过程。关键路径包括：持续产出高质量的管理成果、主动承担更多责任（如带教新人和策划活动）、培养团队管理能力和战略思维、建立良好的社区口碑和团队认可度。晋升通常需要1-3年的积累，取决于个人能力和论坛机会。',
  },
  {
    question: '第一版主如何处理版块内的争议和冲突？',
    answer: '处理争议和冲突时，第一版主应遵循以下原则：保持中立公正的立场，不偏袒任何一方；充分了解事件经过和各方观点后再做判断；优先采用沟通和调解的方式解决问题；处理决定要有明确的规则依据；给予当事方申诉和反馈的渠道。重大争议建议团队讨论后决策。',
  },
  {
    question: '第一版主如何提升版块的活跃度？',
    answer: '提升版块活跃度可以从多个维度入手：策划有吸引力的主题活动激励用户参与、培育优质内容创作者并给予充分曝光和激励、优化新用户的引导流程降低参与门槛、建立良性的互动氛围鼓励用户之间积极交流、定期分析数据找出活跃度瓶颈并针对性优化。',
  },
  {
    question: '第一版主如何管理版主团队？',
    answer: '高效的版主团队管理包括：根据成员特长安心合理分工、建立清晰的协作流程和沟通机制、定期举行团队会议进行经验分享和问题讨论、设计激励体系保持团队积极性、为新版主提供培训和指导、建立明确的绩效考核标准。关键是营造相互信任、积极协作的团队文化。',
  },
];